<template>
  <div
    v-if="product"
    class="border-2 border-gray-200 p-3 rounded-lg flex-row space-y-5"
  >
    <div class="flex flex-row items-center">
      <h3 class="flex-1 text-sm uppercase font-semibold">
        Select Amount
      </h3>
      <div class="justify-end">
        <select
          v-model="selectedVariant"
          class="input input-select"
        >
          <option
            v-for="variant in product.variants"
            :key="variant.id"
            :value="variant"
          >
            {{ variant.title }}
          </option>
        </select>
      </div>
    </div>
    <add-to-cart-button
      v-if="product && selectedVariant"
      :variant="selectedVariant"
      :gtm-label="`${product.title} - ${selectedVariant.title}`"
      @click="$cart.add(product, selectedVariant)"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useProductsStore } from '@/stores'
import { getTemplateData } from '@/utils'
import type { Variant } from '@/types/shopify'
import AddToCartButton from '@/components/shared/add-to-cart-button.vue'
import { storeToRefs } from 'pinia'
const store = useProductsStore()
const { product } = storeToRefs(store)
const selectedVariant = ref<Variant | undefined>()
store.product = getTemplateData('#json-product')
selectedVariant.value = product.value?.variants?.[0]
</script>
